module.exports = __webpack_public_path__ + "static/scale-model-of-boyd-hill-nature-preserve-in-st.-petersburg-florida-078924a9443bea4db94776936f8bbd24.png";